import { makeQueryOptions } from '@mint-lib/api-zod-support/react-query';

import { defaultApi } from '@mint-sdk/api-core';
import { z } from 'zod';

import {
  CreateUploadUrlRequestSchema,
  CreateUploadUrlResponseSchema,
  FileListResponseSchema,
  type FileItemSchema,
} from '../shared/schemas/file.js';

export { PlanFileTypeEnum } from '../shared/schemas/file.js';
export type FileItem = z.infer<typeof FileItemSchema>;
export type FileListResponse = z.infer<typeof FileListResponseSchema>;
export type CreateFileUploadUrlPayload = z.infer<
  typeof CreateUploadUrlRequestSchema
>;

export const removeFile = defaultApi.declareEndpoint({
  url: 'planning-service/media-plans/$planId/files/$fileId' as const,
  method: 'DELETE',
  responseSchema: z.string(),
});

export const getFileList = defaultApi.declareEndpoint({
  url: 'planning-service/media-plans/$planId/files' as const,
  method: 'GET',
  responseSchema: FileListResponseSchema,
});

export const getFileListQueryOptions = makeQueryOptions(getFileList, {
  processResponse(data) {
    return data;
  },
});

export const createFileUploadUrl = defaultApi.declareEndpoint({
  url: 'planning-service/media-plans/$planId/upload_urls/' as const,
  method: 'POST',
  requestSchema: CreateUploadUrlRequestSchema,
  responseSchema: CreateUploadUrlResponseSchema,
});

export const confirmFileUploadStatus = defaultApi.declareEndpoint({
  url: 'planning-service/media-plans/$planId/files/$fileId/confirm/' as const,
  method: 'PATCH',
  responseSchema: z.null(),
});
